import { memo } from "react";
import * as Styled from "./style";

type ButtonItemProps = {
  name: string;
  isGravure?: boolean;
  handleClick: () => void;
};

export const _ButtonItem = (props: ButtonItemProps) => {
  const { name, isGravure = false, handleClick } = props;
  return (
    <Styled.ButtonItem type="button" onClick={handleClick}>
      <Styled.SpanText>{name}</Styled.SpanText>
      {isGravure && <Styled.SpanGravureText>&nbsp;(グラビア)</Styled.SpanGravureText>}
    </Styled.ButtonItem>
  );
};

export const ButtonItem = memo(_ButtonItem);
